const axios = require('axios');
import apiUrl from '../../api.config';

const REPORT_API_URL = `${apiUrl}report`;

const ReportService = {
    getAll() {
        return axios.get(REPORT_API_URL + '/getAll', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    add(reportData) {
        return axios.post(REPORT_API_URL + '/add', reportData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    getBySchool() {
        return axios.get(REPORT_API_URL + '/getBySchool', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(reportId, reportData) {
        return axios.put(REPORT_API_URL + '/update/' + reportId, reportData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(reportIds) {
        return axios.delete(REPORT_API_URL + '/delete/' + reportIds, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default ReportService;